import axios from 'axios'
import { useContext } from 'react'
import React from 'react'
import ENDPOINT from '../data/ENDPOINT'
import SecurityHeaders from '../data/SecurityHeaders'
import FetchFingerprint from './FetchFingerprint'

const GetAccount = async ({user,fingerprint})=>{

   
const data = new FormData()

data.append("session",user.SessionId)
data.append("fp",fingerprint)
const res = await 
axios.post(ENDPOINT+"get-account.php",data,SecurityHeaders)
if(res){
   
     return res.data
}

}
export default GetAccount